<template>
  <div class="container-wrap">
    <div class="logo"><img :src="logo" /></div>
    <div class="bg-wrap" :style="setBg">
      <!-- 跟随背景图一起配置 -->
      <!-- <div class="title"> -->
      <!-- <img src="@img/cata-title.png" /> -->
      <!-- </div> -->
      <!-- <div class="title">压力容器安全现场检查</div> -->
      <div class="cata-wrap">
        <div class="cata-wrap-container">
          <!-- <div class="demo"  v-for="(item, index) in data">{{index}}</div> -->
          <!-- <div class="card-title mb-20" @click="handleClick(item)">{{ item.title }}</div> -->
          <base-card :bg="index + 1" class="mb-20" :data="item" v-for="(item, index) in data" :key="item.id"></base-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchBg, fetchCata, fetchProject } from '@/api/sys'

export default {
  computed: {
    setBg() {
      return {
        backgroundImage: `url(${this.url})`
      }
    }
  },
  data() {
    return {
      url: '',
      projectUrl: '',
      logo: '',
      data: [],
      id: ''
    }
  },
  methods: {
    async initProject() {
      const projectUrl = location.href.split('//')[1].split('/')[1]
      this.projectUrl = projectUrl
      const res = await fetchProject({ url: projectUrl })
      this.logo = res.data.logo
      this.id = res.data.id
    },
    async loadBg() {
      const { data } = await fetchBg({ project_id: this.id, type: 2 })
      this.url = data.pc_image
      console.log('this.url :>> ', this.url)
    },
    async loadCata() {
      const { data } = await fetchCata({ project_id: this.id })
      console.log('data :>> ', data)
      this.data = data
    },
    handleClick(row) {
      if (row.html_url) window.location.href = row.html_url
    }
  },
  async created() {
    await this.initProject()
    await this.loadBg()
    this.loadCata()
  }
}
</script>

<style lang="scss" scoped>
.container-wrap {
  box-sizing: border-box;
  position: relative;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('~@img/h5/手机背景.png');
  padding: 42px 78px;
  min-width: 1366px;

  .logo {
    width: 394px;
    height: 71px;
    margin-bottom: 20px;
    img {
      width: 100%;
    }
  }
  .bg-wrap {
    position: relative;
    width: 100%;
    height: calc(100% - 71px);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .title {
      width: 550px;
      height: 80px;
      img {
        width: 100%;
      }
      // font-size: 34px;
      // font-weight: bold;
      // color: #fff;
    }
    .cata-wrap {
      position: absolute;
      right: 40px;
      top: 50%;
      padding: 30px 40px;
      padding-right: 25px;
      transform: translateY(-50%);
      height: 90%;
      border-radius: 19px 19px 19px 19px;
      background: rgba(0, 30, 79, 0.2);
      .cata-wrap-container {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        padding-right: 30px;
        &::-webkit-scrollbar {
          width: 18px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
          margin-right: 10px;
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(0, 30, 79, 0.2);
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          background: #ededed;
          display: none;
        }

        .card-title {
          cursor: pointer;
          height: 58px;
          background-color: #063cae;
          text-align: center;
          border-radius: 15px;
          font-size: 24px;
          color: #fff;
          line-height: 58px;
          min-width: 200px;
        }
      }
    }
  }
}
</style>
